<template>
  <div class="detached-route-container detchcont">
    <MessageOverlaySkeleton
      v-if="!infoVisible || bc_notSupported"
      class="detchcont_message-overlay gw_mesblock_container"
      :isBlurred="true"
      :isTopDown="true"
      style="--content-margin: auto; --back-from: rgba(0, 0, 0, 0.5); --back-to: rgba(0, 0, 0, 0.5)"
    >
      <div
        v-if="!infoVisible"
        class="gw_mesblock clr-grey"
        data-tst="trainer_learning_mode_message_block"
      >
        <div class="mdi mdi-eye-off text-large"></div>
        <div
          class="gw_mesblock_title clr-grey"
          v-html="$t('messages.trainer_learning_mode_on')"
        />
      </div>
      <div
        v-else
        class="gw_mesblock"
      >
        <div
          class="gw_mesblock_title"
          v-html="$t('messages.bc_not_supported_title')"
        />
        <div class="f-center mt-2">
          <a
            target="_blank"
            href="https://caniuse.com/broadcastchannel"
            class="link-underline link-underline_hover text-normal"
          >
            {{ $t('common.supported_browser_version_list') }}
          </a>
          <i
            class="mdi mdi-chevron-right clr-primary text-semi-large"
            style="line-height: 1"
          ></i>
        </div>
      </div>
    </MessageOverlaySkeleton>

    <div
      v-if="hasMessage"
      class="detchcont_waiting-dots anim-fade-in"
    >
      <WaitingDots
        style="color: var(--clr-grey-2)"
        class="f-center"
      />
    </div>
    <StudyRangesMain
      ref="main"
      rangeTab="range"
      :namespace="''"
      :canAISolve="false"
      style="--clr-back: var(--clr-black-1); --padding-content: 1rem"
      :rangesMaximized="true"
      :hasCenterControls="true"
      :hasTableTile="true"
      :tableGroups="l_sol_dynamic.tableGroups"
      :eqBuckets="l_sol_dynamic.eqBuckets"
      :hero="l_sol_static.hero"
      :opponent="l_sol_static.opponent"
      :combos="l_sol_dynamic.combos"
      :catDraws="l_sol_static.catDraws"
      :catHands="l_sol_static.catHands"
      :catEqBuckets="l_sol_static.catEqBuckets"
      :catEqBucketsAdvanced="l_sol_static.catEqBucketsAdvanced"
      :solution_picked="$store.state.solutions.solution_picked"
      :street="$store.getters.sol_data_street"
      :viewProps="l_viewProps"
      :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
      :filterCombos="$store.getters.sol_filter_combos"
      :filterEvCompare="$store.getters.sol_filter_ev_comparison"
      :filterCategories="$store.getters.sol_filter_categories"
      :evProps="$store.state.solutions.evProps"
      :grouping
      :useHex
      :showBetsIn
      :bettingInfo
      :isPreflop="isPreflop"
      :showFlopContent
      :mobile
      :hasBottom="false"
      :heroGroup="heroDetail.group"
      :opponentGroup="opponentDetail.group"
      :heroGroupId="heroDetail.group_id"
      :opponentGroupId="opponentDetail.group_id"
      :tableMouseover="$store.getters.sol_detail_tableMouseover"
      :heroGroupsIds="heroDetail.groups_ids"
      :opponentGroupsIds="opponentDetail.groups_ids"
      :heroHandsIds="heroDetail.hands_ids"
      :opponentHandsIds="opponentDetail.hands_ids"
      :filteredHeroHandsIds="heroDetail.hands_ids"
      :filteredOpponentHandsIds="opponentDetail.hands_ids"
      :hasPremiumGameformat
      :gameformat
      :hSpot="$store.getters.sol_data_hSpot"
      :handInfo="handInfo"
      :hasFilterPills="true"
      :hasRangeControls="true"
      :hasShortcutBtn="false"
      :learningMode="!infoVisible"
      :skeletonOnly="!infoVisible || !apiData"
      :max1280="max1280"
      :ccProps="l_ccProps"
      @eqchart:click="handleEqChartClick"
    />

    <div class="ma-auto"></div>
  </div>
</template>

<script>
import WaitingDots from '@/components/PokerTable/WaitingDots'
import broadcast_mix from '@/mixins/broadcast_mix'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import StudyRangesMain from '@/components/Study/StudyRangesMain'

export default {
  name: 'DetachedTrainerInfo',
  components: {
    StudyRangesMain,
    MessageOverlaySkeleton,
    WaitingDots,
  },
  mixins: [broadcast_mix],
  data() {
    return {
      apiData: null,
      gameformat: null,
      infoVisible: false,
      loading: false,
    }
  },
  created() {
    this.bc_channelname = this.$route.query.bc_channelname
    if (!this.bc_channelname) {
      console.warn('no bc_channelname provided')
      return
    }
    this.bc_initialize()
    this.registerReceiver()
  },
  methods: {
    handleEqChartClick() {
      this.$store.dispatch('router_set_dialogs', `chart-eq-dialog`)
    },
    bc_handleMessage(message) {
      const code = message?.data?.data?.code
      const status = message?.data?.data?.status
      const value = message?.data?.data?.value

      if (code === 'bc_send') {
        this.loading = false

        if (status === 'loading') {
          this.loading = value.loading
          return
        }
        if (status === 'ok') {
          const { trigger } = value

          if (trigger === 'infoVisible') {
            this.infoVisible = value.infoVisible
            return
          }

          this.infoVisible = value.infoVisible
          this.apiData = value.apiData
          this.gameformat = value.gameformat

          // for eq chart dialog
          this.$store.commit(`api_update_data`, {
            key: 'api_poker_solution',
            data: value.apiData,
          })

          if (this.$refs.main) {
            this.$refs.main.closeFloatingCombos()
          }
          this.$store.dispatch('sol_data_initialize', { apiData: value.apiData })

          this.$store.dispatch(`router_update_query`, {
            query: value.query,
            push: false,
          })
          return
        }
        if (status === 'no-data') {
          this.apiData = null
        }
        return
      }

      if (code === 'trbc_register_main') {
        this.registerReceiver()
      }
    },
    registerReceiver() {
      this.bc_postMessage({ code: 'trbc_register_receiver' })
    },
  },
  computed: {
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    opponentDetail() {
      return this.$store.getters.sol_detail_players[1]
    },
    l_ccProps() {
      const stratab = this.$store.getters.sw_study_range_center === 'strategy'

      return {
        handsPinnedHero: this.handInfo ? [this.handInfo.hand] : null,
        hasTableTile: true,

        hasFilterSuitsItem: !stratab,
        hasHorizontalChartItem: stratab,
        hasHorizontalChart: stratab,

        hasHandStrengthItem: this.showFlopContent && stratab,
        hasHandStrength: this.showFlopContent && stratab,
        hasRangeCategoriesItem: this.showFlopContent && stratab,
        hasRangeCategories: this.showFlopContent && stratab,
        hasRangeCategoriesHands: this.showFlopContent && stratab,
        hasRangeCategoriesDraws: this.showFlopContent && stratab,

        hasRangesComparisonItem: !stratab,
        hasRangesComparison: !stratab,
        hasEqChartItem: this.showFlopContent && !stratab,
        hasEqChart: this.showFlopContent && !stratab,
      }
    },
    l_viewProps() {
      const heroShowProp = this.$store.getters.sw_range_content_hero.replace('swv_', '')
      const vv = this.$store.getters.sol_view_viewProps
      const res = {
        ...this.$store.getters.sol_view_viewProps,
        hero_showPropHands: heroShowProp,
        hero_showPropTable: heroShowProp,
        hero_valuePropTable: heroShowProp,
        hero_noValueTable: !this.$store.getters.showHandValue || heroShowProp === 'strategy',
        player_showPropHands: vv.player === '0' ? heroShowProp : vv.opponent_valuePropHands,
        hero_emptyTable: !this.showFlopContent
          ? ['eq', 'strategy_eq', 'eqr'].includes(heroShowProp)
          : false,
      }
      return res
    },
    max1280() {
      return this.$store.getters.screen_max1280
    },
    l_sol_dynamic() {
      const res = {
        tableGroups: this.$store.getters.sol_data_tableGroups(),
        combos: this.$store.getters.sol_data_combos(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    l_sol_static() {
      const res = {
        solData: this.$store.getters.sol_data_solData(),
        catDraws: this.$store.getters.sol_data_catDraws(),
        catHands: this.$store.getters.sol_data_catHands(),
        catEqBuckets: this.$store.getters.sol_data_catEqBuckets(),
        catEqBucketsAdvanced: this.$store.getters.sol_data_catEqBucketsAdvanced(),
        players: this.$store.getters.sol_data_players(),
        // TODO rm after 3way rls
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    isPreflop() {
      return this.$store.getters.sol_data_street === 'preflop'
    },
    showFlopContent() {
      return !!this.apiData?.custom_solution_id || !this.isPreflop
    },
    solElite() {
      return this.$store.getters.sol_elite
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },
    bettingInfo() {
      return {
        pot: this.$store.getters.sol_data_hSpot.pot,
        showEvIn: this.$store.getters.show_ev_in,
        showEvIcmIn: this.$store.getters.show_ev_icm_in,
        evIcmConverters: this.l_sol_static.players.map(player => player?.tournament_evs_converter),
      }
    },
    handInfo() {
      return this.apiData?.hand_info
    },
    hasMessage() {
      return !this.apiData || this.loading
    },
  },
}
</script>
<style lang="scss" scoped>
.detchcont {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex: 1;
  height: 100vh;
  width: 100vw;
  background: var(--clr-black-0);
  color: var(--clr-white-0);
  padding: 1rem;
  &_message-overlay {
    position: fixed !important;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
  }

  &_content {
    max-height: var(--vh-100);
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0 !important;
  }
  &_waiting-dots {
    background: var(--clr-black-0);
    position: fixed;
    z-index: 8;
    top: 0;
    padding: 1rem;
    width: 100%;
    max-width: 16rem;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
</style>
